import { request } from './client';
import type { SourcesResponse } from '../connectors/registry';

export function getSources(): Promise<SourcesResponse> {
  return request<SourcesResponse>('/api/sources');
}

export function disconnectSource(id: string): Promise<void> {
  return request<void>(`/api/sources/${id}/disconnect`, {
    method: 'POST',
  });
}

export function connectFreshdesk(domain: string, apiKey: string): Promise<{ agentName: string }> {
  return request<{ agentName: string }>('/api/sources/freshdesk/connect', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ domain, apiKey }),
  });
}
